import style from './block.module.scss';
import { useMediaQuery } from 'react-responsive';
import { SubMenu } from './pratiquesSubMenu';
import clsx from 'clsx';
import { ReactComponent as Arrow } from './arrow-right.svg';

export const Nav = ({ menu, practices }) => {
    const isDesktop = useMediaQuery({
        query: '(min-width: ' + style.tabletBreakpoint + ')',
    });

    return (
        <nav className={style.nav}>
            <ul className={style.desktopul}>
                <li>
                    {!isDesktop && <div className={style.dotedLine}></div>}
                    <span className={style.navItem}>{'NOS PRATIQUES'}</span>
                    <div
                        className={clsx({
                            [style.subMenuContainer]: isDesktop,
                            [style.mobileSubMenu]: !isDesktop,
                        })}
                    >
                        <SubMenu pratiques={practices} isDesktop={isDesktop} />
                    </div>
                </li>

                {menu &&
                    Object.values(menu).map((value, index) => (
                        <li key={index}>
                            {!isDesktop && <div className={style.dotedLine} />}
                            <a href={value.url} className={style.navItem}>
                                <span>{value.title}</span>
                                {!isDesktop && <Arrow className={style.arrow} />}
                            </a>
                        </li>
                    ))}
                {!isDesktop && (
                    <li>
                        <div className={style.dotedLine}></div>
                    </li>
                )}
            </ul>
        </nav>
    );
};
